// extracted by mini-css-extract-plugin
export default {"breadcrumb":"src-pages-Order-AllOrders-OrderList-css-module__breadcrumb--yW+Q6"};